var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "Baidu-Map",
      attrs: {
        "element-loading-text": "地图加载中...",
        "element-loading-spinner": "el-icon-phone-outline",
        "element-loading-background": "rgba(0, 0, 0, 0.7)",
      },
    },
    [
      _c("div", {
        ref: "planMap",
        staticClass: "Plan-Map",
        attrs: { id: "baidu-map" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }